import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import api from "api";

import usePagination from "core/hooks/usePagination";

import { useStart } from "features/start/fabric";


// USER
export const useQueryUser = () => useQuery({
	queryKey: ["user"],
	queryFn: api.user.get
});

export const useMutateUser = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ name, nickname, email, phone }) => api.user.edit({ name, nickname, email, phone }),
		onSuccess: (data) => {
			queryClient.setQueryData(["start"], (state) => ({ ...state, user: data }));
			queryClient.setQueryData(["user"], data);
		}
	});
};

// PROFILE
export const useQueryAccount = () => {
	const start = useStart();
	const profileId = start.profile.id;

	return useQuery({
		queryKey: ["user-profile"],
		queryFn: () => api.profile.get(profileId)
	});
};

export const useMutateReload = () => {
	const queryClient = useQueryClient();
	const start = useStart();
	const profileId = start.profile.id;

	const mutation = useMutation({
		mutationFn: (v) => api.profile.reload({ profileId, ...v }),
		onSuccess: (data) => {
			queryClient.setQueryData(["user-profile"], data);
		}
	});

	const profile = queryClient.getQueryData(["user-profile"]);
	const reload = profile?.reload ? profile?.reload : null;

	const mutateReload = (v) => {
		let reload;
		if (v) reload = v;
		else reload = profile?.reload ? null : start.settings.token.default.amount;

		return mutation.mutate({ reload });
	};
	const mutateThreshold = (v) => mutation.mutate({ reload, threshold: v });

	return { ...mutation, mutateReload, mutateThreshold };
};

export const useQueryDeposits = () => {
	const { page, updatePage } = usePagination();
	const start = useStart();

	const profileId = start.profile.id;
	const take = 10;

	const query = useQuery({
		queryKey: ["profile-deposits", page],
		queryFn: () => api.payment.getDeposits({ profileId, page, take })
	});

	return { ...query, take, updatePage };
};

// HISTORY
export const useQueryHistory = () => {
	const { page, updatePage } = usePagination();
	const take = 10;
	const query = useQuery({
		queryKey: ["user-history", page],
		queryFn: () => api.content.history({ types: ["Unlock", "Gift"], page, take })
	});

	return { ...query, take, updatePage };
};

export const useMutatePass = () => {
	const { page } = usePagination();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (timeId) => api.content.passHistory({ timeId }),
		onSuccess: (contents, timeId) => {
			queryClient.setQueryData(["user-history", page], prev => ({ ...prev, values: prev.values.map(c => c.time?.id == timeId ? { ...c, time: { ...c.time, contents: contents } } : c) }));
		}
	});
};